require('./fiscalProfileSection.scss');

// @vendors
const React = require('react');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { OKLink } = require('commonsComponents/OKLink');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

class FiscalProfileSection extends React.Component {
    render() {
        const sectionTitle = formatText('profile-profile_fiscalTitle');

        return (
            <OKSectionBox className="fiscal-profile-section" title={sectionTitle}>
                <div className="row">
                    <div className="col-xs-12 content-no-padding fiscal-profile-section__description">
                        <FormattedText value="profile-profile_fiscalDescription" />
                    </div>
                    <div className="col-xs-12 content-no-padding last-cell">
                        <OKLink modifier="complementary" to="/myprofile/fiscal">
                            <FormattedText value="profile-profile_fiscalLink" />
                        </OKLink>
                    </div>
                </div>
            </OKSectionBox>
        );
    }
}

module.exports = FiscalProfileSection;
